import type { JSX } from 'react';
import { ArFlag } from './flags/ArFlag';
import { BrFlag } from './flags/BrFlag';

/**
 * A country's flag, inline SVG, never the emoji flag.
 *
 * <p>Lives in `shared/` because it is no longer only a registration control: the
 * hall's balance pill and the wallet hero both carry one, since `Intl` renders
 * ARS as a bare `$` and the figure alone cannot say which market it belongs to.
 *
 * Windows ships no regional-indicator glyphs in Segoe UI Emoji, so a flag emoji
 * renders as two letter boxes there (checklist §3.6 D). Inline SVG also means no
 * network request and no layout shift.
 *
 * Only active markets get a flag. An unknown code falls back to the letter badge
 * the country notice already uses, so opening a market before someone draws its
 * flag degrades to "no flag" rather than a hole in the row.
 */
const FLAGS: Record<string, (props: { size?: number }) => JSX.Element> = {
  BR: BrFlag,
  AR: ArFlag,
};

export function CountryFlag({ code, size = 22 }: { code: string; size?: number }) {
  const Flag = FLAGS[code];
  if (Flag) return <Flag size={size} />;
  return <span className="auth-country-code" aria-hidden="true">{code}</span>;
}
